import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import {
  createScaffolderFieldExtension,
  CustomFieldExtensionSchema,
} from '@backstage/plugin-scaffolder-react';
import {
  ComponentTypePicker,
  ComponentTypePickerSchema,
} from './ComponentTypePicker';

export const ComponentTypePickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'ComponentTypePicker',
    component: ComponentTypePicker,
    schema: ComponentTypePickerSchema as CustomFieldExtensionSchema,
  }),
);
